export interface MapTheme {
  id: string;
  terrain: number;
  terrainAlt: number;
  path: number;
  pathEdge: number;
  grid: number;
  prop: number;
  propEdge: number;
  ambient: 'none' | 'snow' | 'ember' | 'dust' | 'spore';
  ambientColour: number;
  commandColour: number;
  fog: number;
}

export const MAP_THEMES: Record<string, MapTheme> = {
  kappa: {
    id: 'kappa',
    terrain: 0x121a20,
    terrainAlt: 0x0e1418,
    path: 0x2a333b,
    pathEdge: 0x3a4650,
    grid: 0x121a20,
    prop: 0x0e1418,
    propEdge: 0x1e2a34,
    ambient: 'dust',
    ambientColour: 0x6a5a40,
    commandColour: 0x5ec8ff,
    fog: 0x07090d,
  },
  helios: {
    id: 'helios',
    terrain: 0x101820,
    terrainAlt: 0x0c1218,
    path: 0x2a3540,
    pathEdge: 0x4a6070,
    grid: 0x152028,
    prop: 0x0e161c,
    propEdge: 0x2a4050,
    ambient: 'snow',
    ambientColour: 0xa8c8e0,
    commandColour: 0x8ec8ff,
    fog: 0x0a1018,
  },
  cinder: {
    id: 'cinder',
    terrain: 0x1a1410,
    terrainAlt: 0x14100c,
    path: 0x3a2820,
    pathEdge: 0x5a3828,
    grid: 0x1a1410,
    prop: 0x14100c,
    propEdge: 0x3a2820,
    ambient: 'ember',
    ambientColour: 0xff6622,
    commandColour: 0xffaa66,
    fog: 0x0c0806,
  },
  meridian: {
    id: 'meridian',
    terrain: 0x10141c,
    terrainAlt: 0x0c1018,
    path: 0x2a3040,
    pathEdge: 0x4a5068,
    grid: 0x121820,
    prop: 0x0e1218,
    propEdge: 0x2a3040,
    ambient: 'dust',
    ambientColour: 0x8a90a0,
    commandColour: 0xb06cff,
    fog: 0x080a10,
  },
  ashfall: {
    id: 'ashfall',
    terrain: 0x181410,
    terrainAlt: 0x120e0c,
    path: 0x3a3028,
    pathEdge: 0x5a4838,
    grid: 0x181410,
    prop: 0x14100e,
    propEdge: 0x3a3028,
    ambient: 'ember',
    ambientColour: 0xcc4422,
    commandColour: 0xff8866,
    fog: 0x0a0806,
  },
  theta: {
    id: 'theta',
    terrain: 0x0e1614,
    terrainAlt: 0x0a1210,
    path: 0x243830,
    pathEdge: 0x3a5048,
    grid: 0x0e1614,
    prop: 0x0a1210,
    propEdge: 0x243830,
    ambient: 'spore',
    ambientColour: 0x7dce5a,
    commandColour: 0x7dce5a,
    fog: 0x060a08,
  },
  obsidian: {
    id: 'obsidian',
    terrain: 0x1a1412,
    terrainAlt: 0x120d0b,
    path: 0x3a3230,
    pathEdge: 0x6a4a3a,
    grid: 0x211614,
    prop: 0x16100e,
    propEdge: 0x4a2a1e,
    ambient: 'ember',
    ambientColour: 0xff6a2a,
    commandColour: 0xffb36a,
    fog: 0x0c0806,
  },
  cryostation: {
    id: 'cryostation',
    terrain: 0x111a25,
    terrainAlt: 0x0b121c,
    path: 0x2c3c4e,
    pathEdge: 0x6a9ab8,
    grid: 0x142333,
    prop: 0x0d1622,
    propEdge: 0x2a526c,
    ambient: 'snow',
    ambientColour: 0x9bdcff,
    commandColour: 0x9bdcff,
    fog: 0x08101a,
  },
  floodway: {
    id: 'floodway',
    terrain: 0x111722,
    terrainAlt: 0x0b1019,
    path: 0x2a3546,
    pathEdge: 0x637a9c,
    grid: 0x182238,
    prop: 0x0e141e,
    propEdge: 0x31405a,
    ambient: 'dust',
    ambientColour: 0x8b8dff,
    commandColour: 0x9b7dff,
    fog: 0x080a12,
  },
  verdigris: {
    id: 'verdigris',
    terrain: 0x121b1a,
    terrainAlt: 0x0c1413,
    path: 0x2e3b37,
    pathEdge: 0x5f8879,
    grid: 0x15231f,
    prop: 0x0c1512,
    propEdge: 0x2b5a4a,
    ambient: 'spore',
    ambientColour: 0x71d6b5,
    commandColour: 0x74d6bd,
    fog: 0x060c0a,
  },
  umbra: {
    id: 'umbra',
    terrain: 0x11151f,
    terrainAlt: 0x0a0e16,
    path: 0x2b3444,
    pathEdge: 0x637187,
    grid: 0x151b2a,
    prop: 0x0b1019,
    propEdge: 0x30445d,
    ambient: 'dust',
    ambientColour: 0x8c9fbd,
    commandColour: 0x9ad4ff,
    fog: 0x070a12,
  },
  aurora: {
    id: 'aurora',
    terrain: 0x101a24,
    terrainAlt: 0x0a141d,
    path: 0x2f4657,
    pathEdge: 0x79c8e8,
    grid: 0x142534,
    prop: 0x0d1721,
    propEdge: 0x315a72,
    ambient: 'snow',
    ambientColour: 0x75e6ff,
    commandColour: 0x84e9ff,
    fog: 0x07101a,
  },
  emberfall: {
    id: 'emberfall',
    terrain: 0x1b1311,
    terrainAlt: 0x120b0a,
    path: 0x48302a,
    pathEdge: 0xc05b34,
    grid: 0x241713,
    prop: 0x17100e,
    propEdge: 0x6e3425,
    ambient: 'ember',
    ambientColour: 0xff7b32,
    commandColour: 0xffb36a,
    fog: 0x0d0705,
  },
  tideline: {
    id: 'tideline',
    terrain: 0x0d1b23,
    terrainAlt: 0x08131b,
    path: 0x2b5362,
    pathEdge: 0x68d2d7,
    grid: 0x102b36,
    prop: 0x0a151c,
    propEdge: 0x2a5d68,
    ambient: 'dust',
    ambientColour: 0x5cd9d1,
    commandColour: 0x71e6dd,
    fog: 0x050d13,
  },
};

export function getTheme(id: string): MapTheme {
  return MAP_THEMES[id] ?? MAP_THEMES.kappa;
}
